import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    TextField,
    InputAdornment,
    IconButton,
    Checkbox,
    ButtonGroup,
    Grid2,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { AddBox, AddCircle, CheckBox, CheckBoxOutlineBlank, Delete, RemoveCircle, Save, Search } from '@mui/icons-material';

import { useSearchParams } from 'react-router-dom';
import { makeid, myTimestampToDate } from '../utils/ui_utils';
import { LoadingButton } from '@mui/lab';
import { useAuth } from '../core/AuthProvider';
import { globalstyles } from '../lib/definitions';



const newaward = {
    position_list: [1,2]
}





export const MatchSourceDialog = forwardRef(({ edit_fn, _award_filter_subdict }, ref) => {
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newaward })
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [isInvalid, setIsInvalid] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)
    const [curMatch, setMatch] = useState()
    const [curAward, setAward] = useState()
    const [searchParams, setSearchParams] = useSearchParams()






    useImperativeHandle(ref, () => {
        return {
            onNew(match) {
                setMatch(match)
                setCurElement({ ...newaward, 
                    position_list: [1,2]
                 })
                setIndex(-1)
                setIsNew(true)
                setIsEdited(true)
                setOpen(true);
            },
            onEdit(el, i, match, award) {
                setMatch(match)
                setAward(award)
                setOpen(true);
                setIsNew(false)
                let _el = { ...newaward, ...el }
                setCurElement(_el)
                setIndex(i)
                setIsEdited(false)
            }
        }
    })


    const handleClose = () => {
        setSearchParams({})
        setOpen(false);
    };


    const handleSave = () => {
        edit_fn(curElement, curMatch.id, curAward.id)
        setOpen(false)
    }



    const onChangeHandlerPosition = (el, index) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'checkbox') {
            value = el.checked
        } else if (type === 'number') {
            value = parseInt(value)
        }

        if (value !== undefined) {
            let _p_list = [...curElement.position_list]
            _p_list.splice(index, 1, parseInt(value))
            setCurElement({ ...curElement, [name]: _p_list })
            setIsEdited(true)
        }
    }

    const onChangeHandler = (el, index) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'checkbox') {
            value = el.checked
        } else if (type === 'number') {
            value = parseInt(value)
        }

        if (value !== undefined) {
            setCurElement({ ...curElement, [name]: value })
            setIsEdited(true)
        }
    }






    useEffect(() => {
        console.log("SOURCE DIALOG", curElement.position_list)
    }, [curElement])




    const incrementValue = (name, index) => {
        let _p_list = [...curElement.position_list]
        let value = parseInt(_p_list[index]) + 1
        _p_list.splice(index, 1, value)
        setCurElement({ ...curElement, [name]: _p_list })
        setIsEdited(true)

    }
    const decrementValue = (name, index) => {
        let _p_list = [...curElement.position_list]
        let value = parseInt(_p_list[index]) - 1
        _p_list.splice(index, 1, value)
        setCurElement({ ...curElement, [name]: _p_list })
        setIsEdited(true)

    }


    const addPosition = () => {
        let _p_list = [...curElement.position_list]
        const new_p = _p_list.length > 0 ? parseInt(_p_list[_p_list.length - 1]) + 1 : 1
        _p_list.push(new_p)
        const name = 'position_list'
        setCurElement({ ...curElement, [name]: _p_list })
        setIsEdited(true)
    }

    const removePosition = (k) => {
        let _p_list = [...curElement.position_list]
        _p_list.splice(k, 1)
        const name = 'position_list'
        setCurElement({ ...curElement, [name]: _p_list })
        setIsEdited(true)
    }


    return (
        <div>

            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth={true}>
                <DialogTitle>
                    Soggetti inseriti da:  <b>{curMatch?.match_name}</b> - {curAward?.award_name}
                </DialogTitle>
                <DialogContent sx={{minHeight:250}}>
                    {curAward?.has_position &&
                        <>
                            <Grid2 container sx={{mb:1}}>
                                <Grid2 size={6}>
                                    seleziona filtro
                                </Grid2>
                                <Grid2>
                                    <ButtonGroup>
                                        {curAward.filter_data_list?.sort().map((f, k) => (
                                            <Button
                                                key={k}
                                                variant={curElement.filter_applied === f ? "contained" : 'outlined'}
                                                size="small"
                                                onClick={() => onChangeHandler({ name: 'filter_applied', value: f })} color={_award_filter_subdict[f]?.color}
                                                startIcon={curElement.filter_applied === f ? <CheckBox /> : <CheckBoxOutlineBlank />}
                                            >
                                                {_award_filter_subdict[f]?.label}
                                            </Button>
                                        ))}
                                    </ButtonGroup>
                                </Grid2>
                            </Grid2>


                            <Grid2 container sx={{ alignItems: 'center', ...globalstyles.listHeader }}>
                                <Grid2 size={6}>
                                    posizione
                                </Grid2>
                                <Grid2>
                                    <Button variant="contained" size="small" onClick={addPosition} startIcon={<AddBox />}>Aggiungi posizione</Button>
                                </Grid2>
                            </Grid2>
                            {curElement.position_list.length=== 0 &&
                            <Box sx={{color: 'red'}}>Aggiungi almeno una posizione</Box>
                            }
                            {curElement.position_list?.map((p, k) => (

                                <Grid2 container sx={{ alignItems: 'center', ...globalstyles.list_row }}>
                                    <Grid2 size={6}>

                                        <TextField
                                            margin="dense"
                                            id="positions"
                                            name="positions"
                                            variant="standard"
                                            type="number"
                                            value={p}
                                            onChange={(ev) => onChangeHandlerPosition(ev.target, k)}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton edge="end" color="primary" onClick={() => incrementValue('position_list', k)}>
                                                            <AddCircle />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <IconButton disabled={parseInt(p) < 2} edge="start" color="primary" onClick={() => decrementValue('position_list', k)}>
                                                            <RemoveCircle />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid2>
                                    <Grid2>
                                        <Button size="small" variant="outlined" color="error" onClick={() => removePosition(k)} startIcon={<Delete />}></Button>
                                    </Grid2>
                                </Grid2>
                            ))}
                        </>}

                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                        <LoadingButton key={'bs'} disabled={isInvalid} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingPosition="start">Salva</LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
})



